export default __webpack_public_path__ + "static/media/logo-scratchpay-text-white.1e5ad656.png";